import { useContext } from 'react'
import DictionaryContext, {
	DictionaryContextInterface,
} from '../context/DictionaryContext'

const useDictionary = (): DictionaryContextInterface =>
	useContext(DictionaryContext)

export default useDictionary
